/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiClientsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const deleteApiClientsId200Schema = z.any();

export const deleteApiClientsIdMutationResponseSchema = z.lazy(
  () => deleteApiClientsId200Schema,
);
